var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.6913 0.685008L12.316 0.309877C11.9041 -0.103292 11.2291 -0.103292 10.8158 0.309877L4.44416 6.68711L2.18325 4.42539C1.77126 4.01266 1.09583 4.01266 0.683843 4.42583L0.308991 4.80052C-0.102997 5.21325 -0.102997 5.88875 0.308991 6.30148L3.69227 9.69078C4.10469 10.1031 4.77969 10.1031 5.19211 9.69078L12.6913 2.18597C13.1029 1.77324 13.1029 1.09774 12.6913 0.685008Z","fill":"#2FBF84"}));
}

Check.defaultProps = {"width":"13","height":"10","viewBox":"0 0 13 10","fill":"none"};

module.exports = Check;

Check.default = Check;
